import {
  CREDIT_AGENT_START,
  CREDIT_AGENT_ERROR,
  CREDIT_AGENT_SUCCESS,
} from 'constants/action-types/wallets/creditAgent';

import apiAction from 'helpers/apiAction';
import {
  CREDIT_DESTINATION_USER,
  CREDIT_DESTINATION_GROUP,
} from 'constants/walletCreditDefaults';
import notificationHelper from 'helpers/notificationHelper';
import { ERROR } from 'constants/notificationStatus';

const onSuccess = (dispatch, payload) => {
  dispatch({ type: CREDIT_AGENT_SUCCESS, payload });
  notificationHelper({ message: payload.message });
};

const onFailure = (dispatch, error) => {
  dispatch({ type: CREDIT_AGENT_ERROR, error });
  if (error) {
    if (!error.errors) {
      notificationHelper({ message: error.message, status: ERROR });
    }
    if (error.errors) {
      notificationHelper({
        message: error.errors[0].message,
        status: ERROR,
      });
    }
  }
};

export const creditAgent = (data, agentId) => dispatch =>
  dispatch(
    apiAction({
      url: `/wallets/agents/${agentId}`,
      method: 'POST',
      data: {
        amount: data.amount,
        purpose: data.description,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => onSuccess(dispatch, payload),
      onFailure: error => onFailure(dispatch, error),
      onEnd: () => false,
    }),
  );

export const creditGroup = (
  data,
  groupId,
  { onSuccessCallback, onFailureCallback } = {},
) => dispatch =>
  dispatch(
    apiAction({
      url: '/wallets/requests/top-up/group',
      method: 'POST',
      data: {
        destination: CREDIT_DESTINATION_GROUP,
        organization_id: data.organization_id || undefined,
        group_id: groupId,
        channel: data.channel,
        source: data.source,
        amount: data.amount,
        description: data.description,
        password: data.password,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => {
        onSuccess(dispatch, payload);
        if (onSuccessCallback) onSuccessCallback(payload);
      },
      onFailure: error => {
        onFailure(dispatch, error);
        if (onFailureCallback) onFailureCallback(error);
      },
      onEnd: () => false,
    }),
  );

export const creditUser = (
  data,
  userId,
  { onSuccessCallback, onFailureCallback } = {},
) => dispatch =>
  dispatch(
    apiAction({
      url: '/wallets/requests/top-up/user',
      method: 'POST',
      data: {
        destination: CREDIT_DESTINATION_USER,
        organization_id: data.organization_id || undefined,
        user_id: userId,
        channel: data.channel,
        source: data.source,
        amount: data.amount,
        description: data.description,
        password: data.password,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => {
        onSuccess(dispatch, payload);
        if (onSuccessCallback) onSuccessCallback(payload);
      },
      onFailure: error => {
        onFailure(dispatch, error);
        if (onFailureCallback) onFailureCallback(error);
      },
      onEnd: () => false,
    }),
  );

export const creditBulkUsers = (
  data,
  { onSuccessCallback, onFailureCallback } = {},
) => dispatch =>
  dispatch(
    apiAction({
      url: '/wallets/requests/bulk-top-up/user',
      method: 'POST',
      data: {
        users: data.users,
        source: data.source,
        destination: CREDIT_DESTINATION_USER,
        channel: data.channel,
        organization_id: data.organization_id || undefined,
        description: data.description,
        password: data.password,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => {
        onSuccess(dispatch, payload);
        if (onSuccessCallback) onSuccessCallback(payload);
      },
      onFailure: error => {
        onFailure(dispatch, error);
        if (onFailureCallback) onFailureCallback(error);
      },
      onEnd: () => false,
    }),
  );

export const creditBulkGroups = (
  data,
  { onSuccessCallback, onFailureCallback } = {},
) => dispatch =>
  dispatch(
    apiAction({
      url: '/wallets/requests/bulk-top-up/group',
      method: 'POST',
      data: {
        groups: data.groups,
        source: data.source,
        destination: CREDIT_DESTINATION_GROUP,
        channel: data.channel,
        organization_id: data.organization_id || undefined,
        description: data.description,
        password: data.password,
      },
      API_REQUEST_START: CREDIT_AGENT_START,
      API_REQUEST_SUCCESS: CREDIT_AGENT_SUCCESS,
      API_REQUEST_FAILURE: CREDIT_AGENT_ERROR,
      onSuccess: payload => {
        onSuccess(dispatch, payload);
        if (onSuccessCallback) onSuccessCallback(payload);
      },
      onFailure: error => {
        onFailure(dispatch, error);
        if (onFailureCallback) onFailureCallback(error);
      },
      onEnd: () => false,
    }),
  );
